export { LockClosed } from './lock-closed'
